const priorityOptions = [
    {
        id: 1,
        value: "high"
    },
    {
        id: 2,
        value: "medium"
    },
    {
        id: 3,
        value: "low"
    },
]

export default priorityOptions;